module.exports = __webpack_public_path__ + "static/media/icon-twitch.72add15d.jpg";